import React, { createContext, useContext, useState, ReactNode } from 'react';

export type ProfileModalTab = 'profile' | 'sponsorship';

interface ProfileModalContextType {
  isProfileModalOpen: boolean;
  initialTab: ProfileModalTab;
  openProfileModal: (tab?: ProfileModalTab) => void;
  closeProfileModal: () => void;
}

const ProfileModalContext = createContext<ProfileModalContextType | undefined>(undefined);

export const useProfileModal = () => {
  const context = useContext(ProfileModalContext);
  if (context === undefined) {
    throw new Error('useProfileModal must be used within a ProfileModalProvider');
  }
  return context;
};

interface ProfileModalProviderProps {
  children: ReactNode;
}

export const ProfileModalProvider: React.FC<ProfileModalProviderProps> = ({ children }) => {
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [initialTab, setInitialTab] = useState<ProfileModalTab>('profile');

  const openProfileModal = (tab: ProfileModalTab = 'profile') => {
    setInitialTab(tab);
    setIsProfileModalOpen(true);
  };

  const closeProfileModal = () => {
    setIsProfileModalOpen(false);
  };

  return (
    <ProfileModalContext.Provider
      value={{
        isProfileModalOpen,
        initialTab,
        openProfileModal,
        closeProfileModal,
      }}
    >
      {children}
    </ProfileModalContext.Provider>
  );
};
